<template>
  <div class="wrapper-breadcrumb">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item v-for="(path, index) in matched" :key="index" :to="path.path">{{
        formatName(path)
      }}</el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
export default {
  name: 'my-bread',
  computed: {
    ...mapState({
      lang: ({ app }) => app.lang
    }),
    ...mapGetters(['roles', 'languages']),
    matched() {
      return this.$route.matched;
    }
  },

  created() {},
  methods: {
    formatName(path) {
      if (['/', ''].indexOf(path.path) > -1) {
        return this.$t('accountmanager.page');
      } else if (['/systemmanagement/safeCenter'].indexOf(path.path) > -1) {
        return this.$t('home.safeCenter');
      } else {
        return this.languages[path.path] && this.languages[path.path][this.lang];
      }
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/cuscom/myBread.vue